<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
        <g fill="none" fill-rule="evenodd">
            <circle cx="13" cy="13" r="13" fill="#EEE"/>
            <g stroke="#666" stroke-linecap="round">
                <path d="M5.8 1.6h0H2c-1.105 0-2 .895-2 2v5.6c0 1.105.895 2 2 2h5.6c1.105 0 2-.895 2-2V5.348h0M4.4 6.8L10.8.4M8.4.4L10.8.4" transform="translate(7.8 7)"/>
                <path d="M9.6 1.6L12 1.6" transform="translate(7.8 7) rotate(90 10.8 1.6)"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'open-new-icon'
}
</script>
